export const trimToNumber = (e) => {
  e.target.value = e.target.value.replaceAll(/[^0-9]/g, '');
};
